import React, { FC } from 'react';
import styles from '../journey-explorer.module.scss';
import { CompareStat } from '../../../../models/journey-explorer/journey-explorer';
import { formatNumber } from '../journey-explorer-utils';

interface CompareStatsProps {
	labels: [string, string];
	a: CompareStat;
	b: CompareStat;
}

const CompareStats: FC<CompareStatsProps> = ({ labels, a, b }) => (
	<div className={styles.compare_stats}>
		{[a, b].map((side, index) => (
			<div key={labels[index]} className={styles.compare_stat}>
				<span className={index === 0 ? styles.compare_a : styles.compare_b}>{index === 0 ? 'A' : 'B'}</span>
				<span className={styles.compare_stat_label} title={labels[index]}>
					{labels[index]}
				</span>
				<span>{formatNumber(side.customers)} customers</span>
				<span className={styles.goal_text}>{side.reached_pct.toFixed(0)}% reached the goal</span>
			</div>
		))}
	</div>
);

export default CompareStats;
